<template lang="pug">
  .notification-form
    b-field(label="Сообщение*",)
      b-input(v-model="value.message", type="textarea", rows="6")

    br
    p Сообщение автоматически исчезнет у всех клиентов через 3 часа
    p Сообщение можно удалить раньше вручную
</template>

<script>
export default {
  name: 'notification-form',
  props: {
    value: Object,
  },
};
</script>

<style scoped></style>
